import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    fetchCampaignsAction,
    fetchCustomers,
} from "../../../../../actions";
import {bbDangerousStringToDate, bbFormattedDateString} from "../../../../../util/bbHelpers";
import BBDataTable from "../../../../../components/customBreachBits/tables/BBDataTable";
import {renderCellExpand} from "../../../../../components/customBreachBits/tables/DataGridRenderCellExpand";
// import Tooltip from "@material-ui/core/Tooltip";
import {BRCustomizedTooltip as Tooltip} from "../../../../../components/customBreachBits/accents/BRCustomizedTooltip";
import {Chip} from "@material-ui/core";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";


const TableAllCustomerCampaigns = ({ title,
                                   verbose= false}) => {

    const {customers, loadingCustomers, loadingCampaigns, loadingCampaignsError} = useSelector(({customer}) => customer);
    // const {authUser} = useSelector(({auth}) => auth);
    const dispatch = useDispatch();

    const customersArr = customers && Object.values(customers);

    const numCampaigns = customers && customersArr.filter((customer)=> customer.campaigns).length

    //creates an array with customers who have campaigns info and then just returns the array containing those campaign info objects
    const campaigns = customers ? customersArr.filter((customer)=> customer.campaigns && !!Object.keys(customer.campaigns).length)
        .map((customer)=>customer.campaigns) : null;

    //puts all campiagn data objects into a single array
    let campaignsOneLevel = [];
    campaigns && campaigns.forEach((campaignObj)=>{
        Object.values(campaignObj).forEach((campaign)=>{
            campaignsOneLevel.push(campaign)
        })
    })

    useEffect(()=>{
        if(!customers && !loadingCustomers){
            dispatch(fetchCustomers())
        }

        if(customers){
            customersArr.forEach((customer)=>{
                const campaignScoped = customer ? customer.campaigns ? customer.campaigns : null : null;
                if(customer && campaignScoped === null && !loadingCampaigns){
                    dispatch(fetchCampaignsAction({
                        customerId: customer.CustomerId
                    }))
                }
            })
        }
    }, [customers, loadingCustomers, campaigns, loadingCampaigns, customersArr, dispatch])

    //function that takes in a single campaign object and returns it's most recent attack date
    const getLastAttackDate = (campaign) => {
        const Attacks  = campaign.Attacks
        const attackDates = []
        if (Attacks && Object.keys(Attacks).length > 0) {
            for (const attack in Attacks) {
                attackDates.push(bbDangerousStringToDate(Attacks[attack]["Start DateTime"]));
            }
            // console.log("attackDates", attackDates)
            attackDates.sort((a, b) => b - a);

            return attackDates[0]
        }
    }

    const getCustomerId = (campaign) => {
        const Attacks = campaign.Attacks
            let customerId;
        if (Attacks && Object.keys(Attacks).length > 0){
            for(const attack in Attacks){
                 customerId = Attacks[attack]["CustomerId"]
            }
            return customerId
        } else {
            return null
        }

    }


    const getAccessStatus = (campaign) =>{
        const Attacks = campaign.Attacks
        let status = 0;
        if(Attacks && Object.keys(Attacks).length > 0){
            for(const attack in Attacks){
                if(Attacks[attack]["Access Gained"]){
                    status += 1
                }
            }
            return status >= 1
        }

    }

    const getAccessDate = (campaign) =>{
        const Attacks = campaign.Attacks
        const accessGainedDates = [];
        if(Attacks && Object.keys(Attacks).length > 0){
            for(const attack in Attacks){
                    accessGainedDates.push(Attacks[attack]["Access Gained DateTime"])
            }
            // console.log("getAccess Date", accessGainedDates)
            accessGainedDates.sort((a,b)=> b - a)
            return accessGainedDates[0]
        }

    }

    const getTargetEmailAddresses = (campaign) => {
        const Attacks = campaign.Attacks
        const targetEmails = [];
        if(Attacks && Object.keys(Attacks).length > 0){
            for(const attack in Attacks){
                    let targetEmail = Attacks[attack]["Details"]["Target Email Address"] && Attacks[attack]["Details"]["Target Email Address"]
                    targetEmails.push(targetEmail)
            }
            return targetEmails
        }
    }

    const tableData = customers && campaignsOneLevel.map((campaign, index)=>{
        return {
            ...campaign,
            numOfAttacks: campaign.Attacks ? Object.keys(campaign.Attacks).length : "0",
            ["Created DateTime"] : bbFormattedDateString(campaign["Created DateTime"], "short"),
            statusName: campaign.Status.Name,
            id: index,
            lastAttackDate: getLastAttackDate(campaign),
            customer: customers[getCustomerId(campaign)] ? customers[getCustomerId(campaign)].CustomerName : null,
            attackSuccess: getAccessStatus(campaign)
                ? `Access Gained`
                : "Attacks Defeated",
            accessDate: getAccessStatus(campaign) ?
                bbFormattedDateString(getAccessDate(campaign), "short")
                : "Access Denied",
            emailSubject: campaign["Phishing Profile Details"]["Email Subject"],
            targetEmails: getTargetEmailAddresses(campaign),
        }
    })

    const userTableHeadings = [
        { field: 'id', headerName: "ID", hide: true, flex: .5, type: "number" },
        { field: 'customer', headerName: "Customer ", hide: false, width: 150, type: "string" },
        { field: 'lastAttackDate', headerName: "Last Attack ", hide: false, width: 120, type: "date",
            renderCell: params =>
                (<div>
                    {bbFormattedDateString(params.value, "short")}
                </div>)
            },
        { field: 'numOfAttacks',renderHeader: (params) =>
                <div style={{lineHeight: "normal"}}>
                        <span>
                            # of <br/>
                            Attacks
                        </span>
                </div>, headerName: "# of Attacks", hide: false, width: 75, type: "number" },
        { field: 'Target Quantity',renderHeader: (params) =>
                <div style={{lineHeight: "normal"}}>
                        <span>
                            # of <br/>
                            Targets
                        </span>
                </div>, headerName: "# of Targets", hide: true, width: 75, type: "number" },
        { field: 'attackSuccess', headerName: "Access Status ", hide: false, width: 140, type: "string",
            renderCell: (params)=>{
                return <>
                <span>
                    <Chip
                        label={`${params.value}`}
                        size={"small"}
                        color={params.value === "Attacks Defeated" ? "default" : "primary"}
                    />
                </span>
                </>
            }},
        { field: 'accessDate', headerName: "Access Gained ", hide: false, width: 120, type: "date" },
        { field: 'statusName', headerName: "Status ", hide: false, width: 100, type: "string",
            renderCell: (params)=>{
            return <>
                <span>
                    <Chip
                        label={`${params.value}`}
                        size={"small"}
                        color={params.value === "Completed" ? "default" : "primary"}
                        />
                </span>
            </>
            }},
        { field: 'emailSubject', headerName: "Email Subject", hide: false, flex: 1, type: "string",
            renderCell: (params)=>
            renderCellExpand(params, (<Tooltip title={``}>
                    <small><code>
                        {params.value}
                    </code></small>
                </Tooltip>
            ))},
        { field: 'targetEmails', headerName: "Targeted Emails", hide: false, flex: 1, type: "string", renderCell: (params)=>
            renderCellExpand (params,
                (<Tooltip title={`${params.value ? params.value.join(", ") : null}`}>
                          <small><code>
                              {params.value ? params.value.join(",         ") : null}
                          </code></small>
            </Tooltip>

        ))},
        { field: 'Created DateTime', headerName: "Created ", hide: false, width: 120, type: "date" },


    ]

    tableData && tableData.sort((a,b)=> b.lastAttackDate - a.lastAttackDate)

    // customers && console.log("campaigns", campaigns, "individual campaigns", campaignsOneLevel)

    const topRightElement =  <Tooltip title={"Social Campaigns across all customers."}>
        <InfoSharpIcon style={{fontSize: "large"}} className={``}/>
    </Tooltip>;

    return(
        <div>
            {(customers
                && campaigns
                && !loadingCampaignsError
                && !loadingCustomers) ?
                (
                    <BBDataTable
                        columns={userTableHeadings}
                        rows={verbose ? tableData : tableData.filter((data)=> data.statusName === "Ongoing")}
                        title={title}
                        topRightElement={topRightElement}
                        progressValue={numCampaigns / customersArr.length * 100}
                        bufferValue={(numCampaigns + 1) / customersArr.length * 100}
                        loading={false}
                        defaultPageSize={10}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                    >
                    </BBDataTable>
                ) :
                ( <BBDataTable
                    columns={userTableHeadings}
                    rows={[]}
                    title={title}
                    loading = {true}
                    progressValue={0}
                    bufferValue={0}
                />)

            }

        </div>
    )

}

export default TableAllCustomerCampaigns;
